<div class="grid grid-cols-12 gap-4 pt-5">

  <!-- MAIN COLUMN -->
  <div class="col-span-12 px-3 2xl:px-6">

    <article>

      <!-- TABLE ACTIONS + TOP PAGINATION -->
      <div class="px-4 pt-4 sm:px-6 2xl:px-8">
        <div class="grid grid-cols-12 items-center gap-4 rounded-2xl bg-white/95 p-4 backdrop-blur">

          <!-- ADD BUTTON -->
          <div class="col-span-12 md:col-span-3 lg:col-span-3">
            <button
              class="primary-btn h-[50px] w-full rounded-xl px-5 text-sm font-semibold transition sm:w-auto"
              (click)="addNewSite()">
              Add Social Page or Site
            </button>
          </div>

          <!-- TOP PAGINATION -->
          <div class="col-span-12 md:col-span-9 lg:col-span-9">
            <div class="flex items-center justify-end">
              <div class="w-fit overflow-hidden rounded-xl bg-white">
                <mat-paginator
                  #topPaginator
                  [length]="totalItems"
                  [pageSize]="12"
                  showFirstLastButtons
                  (page)="onPage('top')">
                </mat-paginator>
              </div>
            </div>
          </div>

        </div>
      </div>

      <!-- TABLE SECTION -->
      <div class="px-4 py-4 sm:px-6 2xl:px-8 2xl:py-6">
        <div class="overflow-hidden rounded-2xl border border-gray-200 bg-white">
          <div class="w-full overflow-x-auto">

            <mat-table
              [dataSource]="dataSource"
              matSort
              class="table-alternate !inline-table !w-full min-w-[900px]">

              <!-- ID -->
              <ng-container matColumnDef="ID">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  ID
                </th>

                <td mat-cell *matCellDef="let element">
                  <span class="font-medium text-gray-700">
                    {{ element.ID }}
                  </span>
                </td>
              </ng-container>

              <!-- Domain -->
              <ng-container matColumnDef="Domain">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Domain
                </th>

                <td mat-cell *matCellDef="let element">
                  <button
                    type="button"
                    class="group inline-flex max-w-[220px] items-center gap-1.5 border-0 bg-transparent p-0 text-left text-gray-800 transition-colors duration-200 hover:text-blue-700 hover:underline focus:outline-none focus:ring-2 focus:ring-blue-100"
                    (click)="editSite(element)"
                    [matTooltip]="'Open domain settings'">

                    <span class="truncate">
                      {{ element.Domain }}
                    </span>

                    <mat-icon
                      inline
                      class="text-gray-400 transition-colors duration-200 group-hover:text-blue-700">
                      edit
                    </mat-icon>
                  </button>
                </td>
              </ng-container>

              <!-- Platform -->
              <ng-container matColumnDef="platform">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Platform
                </th>

                <td mat-cell *matCellDef="let element">
                  <span class="text-gray-700">
                    {{ element.platform }}
                  </span>
                </td>
              </ng-container>

              <!-- Social Page/Site -->
              <ng-container matColumnDef="siteUrl">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Social Page/Site
                </th>

                <td mat-cell *matCellDef="let element">
                  <span class="block max-w-md truncate text-gray-700">
                    {{ element.siteUrl }}
                  </span>
                </td>
              </ng-container>

              <!-- Social Media ID -->
              <ng-container matColumnDef="social_media_id">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Social Media ID
                </th>

                <td mat-cell *matCellDef="let element">
                  <span class="block max-w-xs truncate text-gray-700">
                    {{ element.social_media_id }}
                  </span>
                </td>
              </ng-container>

              <!-- Access Token -->
              <ng-container matColumnDef="access_token">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Access Token
                </th>

                <td mat-cell *matCellDef="let element" class="max-w-xs truncate">
                  <span class="block max-w-xs truncate text-gray-500">
                    {{ element.access_token }}
                  </span>
                </td>
              </ng-container>

              <!-- Status -->
              <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Status Approval
                </th>

                <td mat-cell *matCellDef="let element" class="max-w-xs truncate">
                  <span class="inline-flex max-w-xs items-center rounded-full border border-gray-200 bg-gray-50 px-3 py-1 text-xs font-semibold text-gray-700">
                    {{ element.isApproved }}
                  </span>
                </td>
              </ng-container>

              <!-- Header and Row Definitions -->
              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

            </mat-table>

          </div>
        </div>
      </div>

      <!-- BOTTOM PAGINATION -->
      <div class="px-4 pb-4 sm:px-6 2xl:px-8">
        <div class="flex items-center justify-end rounded-2xl bg-white/95 p-4 backdrop-blur">
          <div class="w-fit overflow-hidden rounded-xl bg-white">
            <mat-paginator
              #bottomPaginator
              [length]="totalItems"
              [pageSize]="12"
              showFirstLastButtons
              (page)="onPage('bottom')">
            </mat-paginator>
          </div>
        </div>
      </div>

    </article>

    <!-- DIALOG TEMPLATES -->
    <ng-template #siteFormTmpl let-dialogData="data">
      <app-site-form
        [formData]="selectedSite"
        [fullLogoPreview]="fullLogoPreview"
        [thumbPreview]="thumbPreview"
        (onSubmitClbk)="onSubmitClbk()">
      </app-site-form>
    </ng-template>

  </div>

</div>